module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.step.kind === 'text') ? _c('div', {
    staticClass: "klickbox-edit-code"
  }, [_c('div', {
    staticClass: "kp-modular-row clearfix"
  }, [_c('label', {
    staticClass: "kp-modular-label label__checkbox"
  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.required_response')))]), _vm._v(" "), _c('div', {
    staticClass: "kp-modular-check pull-right kp-modular-check-without-icon"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.step.required
    },
    on: {
      "change": function($event) {
        return _vm.stepUpdateTextRequired({
          event: $event,
          id: _vm.step.id
        })
      }
    }
  }), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "kp-modular-row clearfix"
  }, [_c('label', {
    staticClass: "kp-modular-label label__checkbox"
  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.multiline_response')))]), _vm._v(" "), _c('div', {
    staticClass: "kp-modular-check pull-right kp-modular-check-without-icon"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.step.text_size === 'long'
    },
    on: {
      "change": function($event) {
        return _vm.stepUpdateTextSize({
          event: $event,
          id: _vm.step.id
        })
      }
    }
  }), _vm._v(" "), _c('span')])])]) : _vm._e()
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-ca64fc20!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/step/config/Text.vue
 ** module id = 907
 ** module chunks = 1
 **/